angular.module('tgaAdmin').controller('DomainLoggingController', [
  '$scope',
  '$state',
  '$window',
  '$uibModalInstance',
  '$translate',
  '$timeout',
  'domainService',
  'desiredDomain',
  'externalLogin',
  'authService',
  function (
    $scope,
    $state,
    $window,
    $uibModalInstance,
    $translate,
    $timeout,
    domainService,
    desiredDomain,
    externalLogin,
    authService,
  ) {
    $scope.viewmodel = {
      processing: false,
      submitButtonActive: false,
      reason: '',
      reasonMessage: '',
      showInputField: false,
      desiredDomain,
      errorMessage: '',
    };

    let authentication;

    $scope.initialize = () => {
      if (externalLogin) {
        authentication = authService.getAuthentication();
        authService.clearAuthentication();
      }
    };

    $scope.processSelect = () => {
      let reasonMessage = '';
      $scope.viewmodel.showInputField = false;
      switch ($scope.viewmodel.reason) {
        case 'other':
          reasonMessage = '';
          $scope.viewmodel.showInputField = true;
          break;
        default:
          reasonMessage = $translate.instant(`domain_logging_modal.reasons.${$scope.viewmodel.reason}`).toString();
          break;
      }
      $timeout(() => {
        $scope.viewmodel.reasonMessage = reasonMessage;
        $scope.viewmodel.submitButtonActive = $scope.viewmodel.reasonMessage.length > 0;
      });
    };

    $scope.processInput = () => {
      const reasonMessage = $scope.viewmodel.reasonMessage || '';
      $scope.viewmodel.submitButtonActive = reasonMessage.length > 0;
    };

    $scope.actions = {
      submit() {
        $scope.actions.setError('');
        $scope.viewmodel.processing = true;
        if (externalLogin) {
          authService.setAuthentication({ ...authentication, remember: false });
        }
        domainService
          .addSuperAdminAccessLog({
            reason: $scope.viewmodel.reasonMessage,
            domain: $scope.viewmodel.desiredDomain,
          })
          .then(() => {
            $uibModalInstance.close({ submitted: true });
          })
          .catch((err) => {
            const { message } = err;
            const genericErrMsg = $translate.instant('banner.create_or_update.failure').toString();
            $scope.actions.setError(message || genericErrMsg);
            if (externalLogin) {
              authService.clearAuthentication();
            }
          })
          .finally(() => {
            $scope.viewmodel.processing = false;
          });
      },
      setError(msg) {
        $scope.viewmodel.errorMessage = msg;
      },
      close() {
        $uibModalInstance.dismiss();
      },
    };

    $scope.initialize();
  },
]);
